<template>
  <section class="section join-beta">
    <div class="container">
      <div class="content has-text-centered">
        <h2 class="has-text-primary">Sign-up</h2>
        <p>Thank you for your interest. ductifi is currently in private beta.</p>
        <p>If you would like to join the beta program, enter your details and
           someone will be in touch with you shortly.</p>
        <button class="button is-primary" v-on:click="displaySignUpForm">
        Join the beta
        </button>
      </div>
      <div class="modal" id="signUpForm">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Contact form</p>
            <button class="delete" aria-label="close" v-on:click="displaySignUpForm"></button>
          </header>
          <section class="modal-card-body">
              <form id='betaForm'>
                <input type="hidden" name="FORM_ID" value="6a787376-d829-446a-ae3b-79cff3247f13">
                <input id="comment-field" type="text" name="COMMENT" />
                <div class="field">
                  <label class="label">First name<sup>*</sup></label>
                  <div class="control">
                    <input class="input" type="text" name="FIRST_NAME" autocomplete="given-name" v-model="givenName">
                  </div>
                </div>
                <div class="field">
                  <label class="label">Last name<sup>*</sup></label>
                  <div class="control">
                    <input class="input" type="text" name="LAST_NAME" autocomplete="family-name" v-model="familyName">
                  </div>
                </div>
                <div class="field">
                  <label class="label">Company</label>
                  <div class="control">
                    <input class="input" type="text" name="ORGANISATION_NAME" autocomplete="organization">
                  </div>
                </div>
                <div class="field">
                  <label class="label">Title</label>
                  <div class="control">
                    <input class="input" type="text" name="JOB_TITLE" autocomplete="organization-title">
                  </div>
                </div>
                <div class="field">
                  <label class="label">Email<sup>*</sup></label>
                  <div class="control has-icons-left has-icons-right">
                    <input class="input" name="EMAIL" type="email" placeholder="Email input" autocomplete="email" v-model="emailValue">
                    <span class="icon is-small is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                    <span class="icon is-small is-right" v-show="$v.emailValue.$invalid">
                      <i class="fas fa-exclamation-triangle"></i>
                    </span>
                  </div>
                </div>
              </form>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-success" v-on:click="performPostRequest" :disabled="$v.validationGroup.$invalid">Submit</button>
          </footer>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'JoinBeta',
  data () {
    return {
      emailValue: '',
      givenName: '',
      familyName: '',
      formWasOk: false
    }
  },
  validations: {
    emailValue: {
      email,
      required
    },
    givenName: {
      required
    },
    familyName: {
      required
    },
    validationGroup: ['givenName', 'familyName', 'emailValue']
  },
  methods: {
    displaySignUpForm () {
      // WTH is tis language?
      var modal = document.getElementById('signUpForm')
      var className = modal.getAttribute('class')
      if (className === 'modal') {
        modal.className = 'modal is-active'
      } else {
        modal.className = 'modal'
      }
    },
    performPostRequest (e) {
      var form = new FormData(document.getElementById('betaForm'))
      let urlEncodedData = []

      for (const [key, value] of form.entries()) {
        urlEncodedData.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
      }

      fetch('https://service.capsulecrm.com/service/newlead', {
        method: 'POST',
        mode: 'no-cors',
        body: urlEncodedData.join('&'),
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded'
        })
      })
        .then(response => {
          console.log(response.type)
          this.displaySignUpForm()
        }).catch(error => {
          console.log(error.stack)
        })
    }
  }
}

</script>
<style type = "text/css" scoped>
#comment-field { display: none; }
</style>



// WEBPACK FOOTER //
// src/components/JoinBeta.vue